import {useQuery} from '@apollo/client';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {sanitiseProductType} from '../../../utils/sanitiseProductType';
import validateUUID from '../../../utils/validateUUID';
import {BUILDER_AD_HOC_FEE_POTS} from '../builderPotQueries';
import {reccNonEditable} from '../CreateBuilder/BuilderSourceDestination/CreateBuilderFooter';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {
  BuilderAdHocFeePots,
  BuilderAdHocFeePotsVariables,
} from '../../../schema-types/BuilderAdHocFeePots';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const useAdHocFeePotsQuery = (): {sourcePots: BuilderPot[]} => {
  const {builderDetails, builderReviewId} = useBuilderContext();
  const {values} = useAutoForm<builderFieldsType>();
  const contactId = values.contact ? validateUUID(values.contact) || null : null;
  const isNonEditable = !!reccNonEditable(builderDetails);

  const {data: potsData} = useQuery<BuilderAdHocFeePots, BuilderAdHocFeePotsVariables>(
    BUILDER_AD_HOC_FEE_POTS,
    {
      variables: {
        reviewId: validateUUID(builderReviewId)!,
        contactId,
        potType: sanitiseProductType(values.mainPlanType) ?? '',
      },
      skip:
        isNonEditable ||
        values.planAction !== OVRecommendActionEnum.AD_HOC_FEE ||
        !values.mainPlanType ||
        !validateUUID(builderReviewId),
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  if (isNonEditable) {
    const savedPot = builderDetails?.chargeAdHocFee?.pot;
    return {
      sourcePots: savedPot ? [savedPot] : [],
    };
  }

  return {
    sourcePots: potsData?.adHocFeePots?.sources ?? [],
  };
};
